module.exports = __webpack_public_path__ + "img/team-member-04.789a87e3.jpg";